import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
  Box,
  Button,
  Flex,
  Heading,
  Text,
  useColorModeValue,
  Container,
  VStack,
  Icon
} from "@chakra-ui/react";
import { MdEmail, MdPhoneIphone } from "react-icons/md";
import menomV2Logo from "../../../assets/img/menomV2Logo.png";

function VerifyEmail() {
  const navigate = useNavigate();
  const { token } = useParams();
  const textColor = useColorModeValue("navy.700", "white");
  const textColorSecondary = useColorModeValue("gray.400", "gray.300");

  useEffect(() => {
    // Mobile app deep link'i dene
    if (token) {
      const deepLink = `menom://verify-email/${token}`;
      
      // iOS ve Android için universal link/app link denemesi
      setTimeout(() => {
        window.location.href = deepLink;
      }, 1000);
    }
  }, [token]);

  return (
    <Container maxW="md" py={12}>
      <Flex direction="column" align="center" justify="center" minH="60vh">
        <Box mb={8}>
          <img src={menomV2Logo} alt="Menom Logo" style={{ maxWidth: "200px" }} />
        </Box>

        <VStack spacing={6} textAlign="center">
          <Icon as={MdEmail} boxSize={16} color="#E45858" />
          
          <Heading size="lg" color={textColor}>
            Email Doğrulama
          </Heading>

          <Text color={textColorSecondary} fontSize="md">
            Email adresinizi doğrulamak için Menom mobil uygulamasını açmanız gerekiyor.
          </Text>

          <Box
            p={6}
            borderRadius="lg"
            bg={useColorModeValue("gray.50", "gray.800")}
            w="100%"
          >
            <VStack spacing={4}>
              <Icon as={MdPhoneIphone} boxSize={8} color="#E45858" />
              <Text fontWeight="bold" color={textColor}>
                Mobil Uygulamayı Açın
              </Text>
              <Text fontSize="sm" color={textColorSecondary}>
                Eğer uygulama otomatik olarak açılmadıysa, lütfen Menom uygulamasını manuel olarak açın.
              </Text>
            </VStack>
          </Box>

          <Button
            colorScheme="red"
            variant="solid"
            onClick={() => {
              if (token) {
                window.location.href = `menom://verify-email/${token}`;
              }
            }}
            w="100%"
          >
            Uygulamayı Aç
          </Button>

          <Text fontSize="xs" color={textColorSecondary}>
            Uygulama yüklü değilse,{" "}
            <Button
              variant="link"
              color="#E45858"
              size="xs"
              onClick={() => navigate("/download")}
            >
              buradan indirebilirsiniz
            </Button>
          </Text>
        </VStack>
      </Flex>
    </Container>
  );
}

export default VerifyEmail;
